var map = {
	"./die-1.svg": "./src/assets/svg/tx-chips/die-1.svg",
	"./die-2.svg": "./src/assets/svg/tx-chips/die-2.svg",
	"./die-3.svg": "./src/assets/svg/tx-chips/die-3.svg",
	"./die-4.svg": "./src/assets/svg/tx-chips/die-4.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/tx-chips sync recursive ^\\.\\/die\\-.*\\.svg$";